import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import sunconure from "assets/sunconure_base.png";
import aviaryMap from "assets/aviary_map.png";
import leavesAsset from "assets/leaves_asset.png";
import badge25 from "assets/25years.png";
import heroFrameUrls from "assets/heroFrames";

const frameUrls = heroFrameUrls;
const FRAME_COUNT = frameUrls.length;

/* ── icons ─────────────────────────────────────────────────────── */
const IconPlay = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
    <polygon points="5,3 19,12 5,21" />
  </svg>
);
const IconTV = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="15" rx="2" />
    <polyline points="17 2 12 7 7 2" />
  </svg>
);
const IconTrophy = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2" />
    <path d="M18 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2" />
    <path d="M6 3h12v8a6 6 0 0 1-12 0V3z" />
    <line x1="12" y1="17" x2="12" y2="21" />
    <line x1="8" y1="21" x2="16" y2="21" />
  </svg>
);
const IconHeart = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);
const IconLeaf = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
  </svg>
);
const IconShield = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);
const IconStar = () => (
  <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor">
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
  </svg>
);
const IconSmTrophy = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2" />
    <path d="M18 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2" />
    <path d="M6 3h12v8a6 6 0 0 1-12 0V3z" />
    <line x1="12" y1="17" x2="12" y2="21" />
    <line x1="8" y1="21" x2="16" y2="21" />
  </svg>
);
const IconSmTV = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="15" rx="2" />
    <polyline points="17 2 12 7 7 2" />
  </svg>
);
const IconSmBird = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 8C8 10 5.9 16.17 3.82 19.82a.5.5 0 0 0 .7.7C7.17 18.33 12 17 16 17h3a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1h-3z" />
    <path d="M9 9H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2" />
  </svg>
);
const IconSmHeart = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);
const IconSmShield = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);


/* ── WHY TRUST US item ──────────────────────────────────────────── */
const TrustItem = ({ icon, label }: { icon: React.ReactNode; label: string }) => (
  <div className="flex items-center gap-2.5 py-1.5">
    <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border border-brand-amber/40 text-brand-amber">
      {icon}
    </span>
    <span className="text-[13px] font-medium text-white/90">{label}</span>
  </div>
);

/* ── Timeline item ──────────────────────────────────────────────── */
const TimelineItem = ({
  icon, title, desc, isLast = false,
}: {
  icon: React.ReactNode; title: string; desc: string; isLast?: boolean;
}) => (
  <div className="flex items-center gap-1.5">
    <div className="flex items-start gap-1.5">
      <span className="mt-0.5 flex-shrink-0 text-brand-amber">{icon}</span>
      <div>
        <p className="text-[11px] font-bold leading-tight text-brand-amber">{title}</p>
        <p className="text-[10px] leading-tight text-white/50">{desc}</p>
      </div>
    </div>
    {!isLast && <span className="mx-1.5 flex-shrink-0 text-xs text-white/25">›</span>}
  </div>
);

/* ── Right panel feature row ────────────────────────────────────── */
const FeatureRow = ({
  icon, title, desc, divider = true,
}: {
  icon: React.ReactNode; title: string; desc: string; divider?: boolean;
}) => (
  <div className={`flex items-start gap-4 py-3 ${divider ? "border-b border-black/10" : ""}`}>
    <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-black/70 text-brand-amber">
      {icon}
    </div>
    <div>
      <h3 className="font-bold text-black">{title}</h3>
      <p className="mt-0.5 text-[13px] leading-snug text-black/60">{desc}</p>
    </div>
  </div>
);

/* ── 4-icon badge strip item ────────────────────────────────────── */
const BadgeItem = ({ icon, label }: { icon: React.ReactNode; label: string }) => (
  <div className="flex flex-col items-center gap-1.5 px-1">
    <span className="text-brand-amber/80">{icon}</span>
    <span className="text-center text-[10px] font-semibold leading-tight text-white/75">{label}</span>
  </div>
);

/* ── Hero ───────────────────────────────────────────────────────── */
// The scroll-driven frame sequence runs at every screen size. On desktop the
// component layers (text, badges, amber panel) sit over the final frame; below
// lg they are hidden entirely, leaving just the zoom-out animation.
const Hero = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const canvasRef    = useRef<HTMLCanvasElement>(null);
  const bgRef        = useRef<HTMLDivElement>(null);
  const leavesRef    = useRef<HTMLImageElement>(null);
  const birdRef      = useRef<HTMLImageElement>(null);
  const textRef      = useRef<HTMLDivElement>(null);
  const frames       = useRef<(HTMLImageElement | null)[]>(new Array(FRAME_COUNT).fill(null));

  useEffect(() => {
    frameUrls.forEach((url, i) => {
      const img = new Image();
      img.onload = () => { frames.current[i] = img; };
      img.src = url;
    });
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    const canvas    = canvasRef.current;
    const bg        = bgRef.current;
    const text      = textRef.current;
    if (!container || !canvas || !bg || !text) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let animId: number;
    let lastIdx = -1;

    // Everything cuts out instantly within the first 1-2 frames of scroll.
    const HOLD = 0.02;

    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      canvas.width  = canvas.offsetWidth  * dpr;
      canvas.height = canvas.offsetHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      lastIdx = -1;
    };

    // The frames are 1920×960 landscape, so a plain cover-fit on a portrait
    // phone crops in on the center third and looks overly zoomed-in. Below lg
    // we pull the cover scale back by this factor (1 = normal cover; smaller =
    // more zoomed out, with the black canvas showing above/below).
    const MOBILE_ZOOM_OUT = 0.5;

    const drawCover = (img: HTMLImageElement) => {
      const cw = canvas.offsetWidth;
      const ch = canvas.offsetHeight;
      let scale = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
      if (cw < 1024) scale *= MOBILE_ZOOM_OUT;
      const iw = img.naturalWidth  * scale;
      const ih = img.naturalHeight * scale;
      ctx.clearRect(0, 0, cw, ch);
      ctx.drawImage(img, (cw - iw) / 2, (ch - ih) / 2, iw, ih);
    };

    const tick = () => {
      const rect  = container.getBoundingClientRect();
      const range = container.offsetHeight - window.innerHeight;
      const target = range > 0 ? Math.max(0, Math.min(1, -rect.top / range)) : 0;

      const idx = Math.min(FRAME_COUNT - 1, Math.round(target * (FRAME_COUNT - 1)));
      let img = frames.current[idx];
      let drawIdx = idx;
      if (!img) {
        for (let d = 1; d < FRAME_COUNT && !img; d++) {
          if (idx - d >= 0 && frames.current[idx - d]) {
            img = frames.current[idx - d]; drawIdx = idx - d;
          } else if (idx + d < FRAME_COUNT && frames.current[idx + d]) {
            img = frames.current[idx + d]; drawIdx = idx + d;
          }
        }
      }
      if (img && drawIdx !== lastIdx) { drawCover(img); lastIdx = drawIdx; }

      const instant = target < HOLD ? "1" : "0";
      if (birdRef.current)   birdRef.current.style.opacity   = instant;
      if (leavesRef.current) leavesRef.current.style.opacity = instant;

      bg.style.opacity     = instant;
      text.style.opacity   = instant;

      animId = requestAnimationFrame(tick);
    };

    resize();
    window.addEventListener("resize", resize);
    animId = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div ref={containerRef} id="hero-section" className="relative h-[300vh]">
      <div className="sticky top-0 h-screen w-full overflow-hidden bg-black">

        <canvas ref={canvasRef} className="absolute inset-0 h-full w-full" />

        {/* Background layer — instant cut on scroll */}
        <div ref={bgRef} className="absolute inset-0 z-10 hidden lg:grid lg:grid-cols-[1.6fr_1fr]">
          <div className="relative flex flex-col overflow-hidden bg-black">
            <img src={aviaryMap} alt="" className="pointer-events-none absolute inset-0 h-full w-full object-cover brightness-60" />
            <div className="absolute inset-0 bg-black/60" />
          </div>
          <div className="relative bg-gradient-to-br from-[#ffc670] via-brand-amber to-[#d3860f]" />
        </div>

        {/* Leaves — instant cut */}
        <img
          ref={leavesRef}
          src={leavesAsset}
          alt=""
          style={{ filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.5))" }}
          className="pointer-events-none absolute -top-[10%] right-[14.46%] z-[14] hidden h-[110%] w-auto max-w-[80%] translate-x-[47.5%] object-contain lg:block"
        />

        {/* Bird — instant cut */}
        <img
          ref={birdRef}
          src={sunconure}
          alt="Sun conure with wings spread"
          className="pointer-events-none absolute bottom-0 right-[38.46%] z-[15] hidden h-[88%] w-auto max-w-[92%] translate-x-[45%] object-contain object-bottom lg:block"
        />

        {/* Text layer — smooth fade on scroll */}
        <div ref={textRef} className="pointer-events-none absolute inset-0 z-20 hidden lg:grid lg:grid-cols-[1.6fr_1fr]">

          {/* ── LEFT ── */}
          <div className="relative flex flex-col justify-end">

            {/* Medallion badge — adjust top-XX and left-XX to reposition */}
            <div className="absolute top-16 hidden lg:left-4 lg:block">
              <img
                src={badge25}
                alt="25 Years of Passion & Trust"
                className="h-[300px] w-auto object-contain"
                style={{ mixBlendMode: "screen" }}
              />
            </div>

            {/* WHY BIRD LOVERS TRUST US card */}
            <div className="absolute bottom-[20%] right-30 z-10 hidden rounded-xl bg-black/70 px-4 py-3 backdrop-blur-sm lg:right-40 lg:block">
              <p className="mb-2 text-[9px] font-extrabold uppercase tracking-[0.18em] text-brand-amber">
                WHY BIRD LOVERS TRUST US
              </p>
              <TrustItem icon={<IconSmTrophy />} label="25+ Years of Experience" />
              <TrustItem icon={<IconSmTV />}     label="National TV Featured" />
              <TrustItem icon={<IconSmTrophy />} label="Award-Winning Aviary" />
              <TrustItem icon={<IconSmHeart />}  label="Family-Owned & Passion Driven" />
            </div>

            {/* Bottom text content */}
            <div className="relative p-8 pb-5 sm:p-10 md:p-14 md:pb-6">

              {/* Established badge */}
              <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-brand-amber/50 bg-black/30 px-4 py-1.5 backdrop-blur-sm">
                <span className="text-brand-amber"><IconStar /></span>
                <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-white">
                  Established Since 2001
                </span>
              </div>

              {/* Heading */}
              <h1 className="max-w-[540px] text-4xl font-extrabold leading-[1.08] text-white [text-shadow:0_2px_16px_rgba(0,0,0,0.7)] sm:text-5xl md:text-[3rem]">
                25+ Years of Passion,<br />Trust &amp; Excellence
              </h1>

              {/* Subtext */}
              <p className="mt-3 max-w-[460px] text-[13px] leading-relaxed text-white/70 sm:text-sm">
                Home to healthy, hand-raised parrots from one of the Philippines' trusted
                family-owned aviaries. For over 25 years, we've been dedicated to responsible
                breeding and exceptional bird care.
              </p>

              {/* CTA row */}
              <div className="mt-5 flex flex-wrap items-center gap-4">
                <Link
                  to="/birds"
                  className="pointer-events-auto rounded-full bg-brand-amber px-6 py-2.5 text-sm font-semibold text-black transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-amber-dark"
                >
                  Visit Our Aviary
                </Link>
                <button className="pointer-events-auto flex items-center gap-2.5 text-white transition-opacity hover:opacity-75">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-white/50 pl-0.5">
                    <IconPlay />
                  </span>
                  <span className="text-sm font-semibold">Watch Our Story</span>
                </button>
              </div>

              {/* Timeline */}
              <div className="mt-4 hidden flex-wrap items-start gap-x-0.5 gap-y-2 border-t border-white/10 pt-4 lg:flex">
                <TimelineItem icon={<IconSmHeart />}  title="2001"                desc="Started with one pair of lovebirds" />
                <TimelineItem icon={<IconSmBird />}   title="Years of Dedication" desc="Expanded our collection and breeding expertise" />
                <TimelineItem icon={<IconSmTV />}     title="National TV Feature" desc="Featured at AHA! segment on GMA" />
                <TimelineItem icon={<IconSmTrophy />} title="Award Winning"       desc="Recognized in bird shows in the Philippines" />
                <TimelineItem icon={<IconSmShield />} title="Trusted Aviary Today" desc="50+ pairs of parrots and counting" isLast />
              </div>
            </div>
          </div>

          {/* ── RIGHT ── */}
          <div className="relative flex flex-col items-center justify-center p-5 sm:p-8 md:p-10">
            <div className="w-full max-w-[360px]">

              {/* Title */}
              <h2 className="text-xl font-bold leading-snug text-black sm:text-[1.6rem]">
                More Than Birds,<br />
                It's a <span className="font-black">25+ Year Journey</span>
              </h2>

              {/* Divider */}
              <div className="my-3 flex items-center gap-3">
                <div className="h-px flex-1 bg-black/15" />
                <span className="text-[10px] text-black/30">✦</span>
                <div className="h-px flex-1 bg-black/15" />
              </div>

              {/* Feature rows */}
              <div className="hidden lg:block">
                <FeatureRow
                  icon={<IconTrophy />}
                  title="25+ Years of Experience"
                  desc="A trusted name in parrot breeding, continuously growing through decades of hands-on care."
                />
                <FeatureRow
                  icon={<IconTV />}
                  title="National TV Featured"
                  desc="Recognized on national television, showcasing our passion and commitment to bird breeding."
                />
                <FeatureRow
                  icon={<IconShield />}
                  title="Award-Winning Aviary"
                  desc="Proud recipient of awards from bird shows across the Philippines for excellence in breeding."
                  divider={false}
                />
              </div>

              {/* 4-icon badge strip */}
              <div className="mt-4 hidden grid-cols-4 rounded-xl bg-black/20 px-2 py-3 lg:grid">
                <BadgeItem icon={<IconTrophy />} label="Award Winning" />
                <BadgeItem icon={<IconTV />}     label="Featured on TV" />
                <BadgeItem icon={<IconLeaf />}   label="Ethical Breeding" />
                <BadgeItem icon={<IconHeart />}  label="Family Owned" />
              </div>

              {/* Stats */}
              <div className="mt-3 grid grid-cols-3 rounded-xl bg-black/25 px-4 py-4">
                <div className="flex flex-col items-center gap-0.5">
                  <span className="text-2xl font-extrabold text-brand-amber">25+</span>
                  <span className="text-center text-[10px] leading-tight text-white/60">Years of Experience</span>
                </div>
                <div className="flex flex-col items-center gap-0.5 border-x border-white/10">
                  <span className="text-2xl font-extrabold text-brand-amber">50+</span>
                  <span className="text-center text-[10px] leading-tight text-white/60">Breeding Parrot Pairs</span>
                </div>
                <div className="flex flex-col items-center gap-1">
                  <span className="text-brand-amber/80"><IconTV /></span>
                  <span className="text-center text-[10px] leading-tight text-white/60">National TV Featured</span>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Hero;
